// Authentication utility functions

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return !!token;
};

export const getUser = () => {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  window.location.href = '/login';
};

export const isSuperuser = () => {
  const user = getUser();
  return user?.role === 'superuser';
};

export const isAdmin = () => {
  const user = getUser();
  return user?.role === 'admin' || user?.role === 'superuser';
};

export const isMember = () => {
  const user = getUser();
  return user?.role === 'member';
};

export const hasPermission = (module) => {
  const user = getUser();
  if (user?.role === 'superuser') return true;
  if (user?.role === 'admin' && !user.permissions) return true; // Legacy admin has all
  if (user?.role === 'member' && module === 'dashboard') return true; // Members have dashboard access
  return user?.permissions?.includes(module) || false;
};

export const getCompanyId = () => {
  // Get from token payload (most reliable)
  const token = getToken();
  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.company_id;
    } catch (e) {
      console.error('Error decoding token:', e);
    }
  }
  
  // Fallback to user object
  const user = getUser();
  return user?.company?.id || user?.tenant?.id;
};